import Link from "next/link";
import { AccordionItemProps } from "@/components/globalAccordion/accordionItem";
import { Path } from "@/navigations/routes";

export const getHomeFaqData = (
  registerLink: string,
  onRegisterClick?: () => void,
): AccordionItemProps[] => [
  {
    title: "How do I send money with SendSprint?",
    content: (
      <>
        Sign up on our{" "}
        <a
          href={registerLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onRegisterClick}
          className="ss:underline"
        >
          website
        </a>
        , verify your identity, add your recipient, and review the fee, exchange
        rate, and amount your recipient will receive before you confirm.
      </>
    ),
  },
  {
    title: "Where is SendSprint available?",
    content:
      "SendSprint is currently available to residents of Alabama, Colorado, Connecticut, the District of Columbia, Florida, Idaho, Illinois, Iowa, Kansas, Maryland, Massachusetts, Michigan, Minnesota, New Jersey, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Dakota, Washington, and Wyoming. If you live in another state, we are not able to open an account for you at this time.",
  },
  {
    title: "Which countries can I send money to?",
    content:
      "You can currently send money to Nigeria, Kenya, and Ghana. Available delivery methods vary by country.",
  },
  {
    title: "How much does it cost?",
    content:
      "Fees and exchange rates depend on the amount, destination, and delivery method. The exact fee, exchange rate, and amount your recipient will receive are always shown before you pay.",
  },
  {
    title: "How long does a transfer take?",
    content:
      "Most transfers are delivered within 30 minutes. Some transfers may take longer because of identity verification, compliance reviews, or the recipient's bank. The estimated delivery time is shown before you send.",
  },
  {
    title: "Why do you need my ID?",
    content:
      "Federal and state law requires money transmitters to verify the identity of their customers. This also helps protect you against fraud.",
  },
  // {
  //   title: "Can I cancel a transfer?",
  //   content:
  //     "[Compliance to confirm cancellation and refund language consistent with the Terms and Conditions and applicable law.]",
  // },
  {
    title: "What if there's a problem with my transfer?",
    content: "Contact us at hi@sendsprint.com or +1 (218) 297-7684.",
  },
  {
    title: "Is SendSprint licensed?",
    content: (
      <>
        Yes. SendSprint Inc. is licensed as a money transmitter (NMLS ID
        1313855) in the states listed on our{" "}
        <Link href={Path.LicensesAndCompliance} className="ss:underline">
          Licenses page
        </Link>
        , and is registered with FinCEN as a Money Services Business. You can
        verify our licenses on NMLS Consumer Access.
      </>
    ),
  },
  {
    title: "How do I file a complaint?",
    content: (
      <>
        Contact our support team first. You may also contact the regulator in
        your state; see our{" "}
        <Link href={Path.StateComplaintDisclosures} className="ss:underline">
          State Complaint Disclosures page.
        </Link>
      </>
    ),
  },
];
